<template>
  <div class="video_warp">
    <div class="video_box">
      <VerticalScreen
        v-if="videoShow"
        :videoInfo="videoInfo"
        @vipBuyShow="vipBuyShow"
        @goldBuyShow="goldBuyShow"
        @watchCountData="watchCountData"
        ref="verticalScreen"
      />
      <div class="layer">
        <div
          class="left"
          :class="{ leftHeight: !(isVip && videoInfo.price == 0) }"
          v-show="isEyeShow"
        >
          <div>
            <div class="flex-aic">
              <div
                class="activityPayBtn mr10"
                v-if="videoInfo.price > 0 && !videoInfo.isBuy"
                @click="paying('gold')"
              >
                <span
                  >{{
                    isVip ? videoInfo.vipPrice : videoInfo.price
                  }}金币购买</span
                >
              </div>
              <div
                class="activityPayBtn"
                v-if="videoInfo.vipPrice > 0 && !videoInfo.isBuy && !isVip"
                @click="toVip"
              >
                <span>开通VIP {{ videoInfo.vipPrice }}金币</span>
              </div>
            </div>
            <div
              class="activityPayBtn"
              v-if="(!isVip &&  freeWatchNum > 0 && videoInfo.price==0 && videoInfo.isVip) || (!isVip &&  freeWatchNum <= 0 && videoInfo.price==0 && isCan)"
            >
              <span>免费视频剩余：{{ freeWatchNum }}</span>
            </div>
            <div
              class="activityPayBtn"
              v-else-if="!isVip && !isCan && videoInfo.price == 0"
              @click="paying('vip')"
            >
              <span class="vip">开通VIP观看完整版</span>
            </div>
            <div
              class="activityPayBtn"
              v-else-if="
                !isVip && videoInfo.price == 0 && isCan && videoInfo.isVip
              "
            >
              <span>每日免费视频</span>
            </div>
          </div>
          <div class="name_box">
            <div class="name ellipsis">
              @{{
                (videoInfo.author && videoInfo.author.nickName) || "未知用户"
              }}
            </div>
          </div>
          <div class="title_text">
            {{ videoInfo.content }}
          </div>
          <div class="tag">
            <div
              class="tag_item ellipsis"
              v-for="item in videoInfo.flags && videoInfo.flags.slice(0, 5)"
              :key="item.id"
            >
              <span
                @click="
                  $router.push({
                    path: '/searchTagResult',
                    query: { name: item },
                  })
                "
                >#{{ item }}</span
              >
            </div>
          </div>
          <div
            class="activityPay"
            v-if="!isVip && newUserTime > 0"
            @click="toVip"
          >
            {{ timeStr }}
          </div>
        </div>
        <div class="right">
          <div class="right_content">
            <div>
              <div
                class="head"
                @click="toBloggerPage(videoInfo.author.id)"
                :style="{ visibility: isEyeShow ? 'visible' : 'hidden' }"
              >
                <ImgDecypt
                  class="avatar"
                  :src="videoInfo.author && videoInfo.author.avatarUrl"
                  round
                  :key="videoInfo.id"
                />
                <div
                  class="add5"
                  @click.stop="focus"
                  v-if="!(videoInfo.author && videoInfo.author.cared)"
                >
                  <div class="add_icon"></div>
                </div>
              </div>
              <div
                class="right_item pt13"
                @click="collecte"
                :style="{ visibility: isEyeShow ? 'visible' : 'hidden' }"
              >
                <svg-icon :icon-class="videoInfo.bLike ? 'xined' : 'xin'" />
                <span>{{ videoInfo.likeNum | watchCount }}</span>
              </div>
              <div
                class="right_item pt13"
                @click="openComments"
                :style="{ visibility: isEyeShow ? 'visible' : 'hidden' }"
              >
                <svg-icon icon-class="msg" />
                <span>{{ videoInfo.commentNum | watchCount }}</span>
              </div>
              <div
                class="right_item pt13"
                @click="openShare"
                :style="{ visibility: isEyeShow ? 'visible' : 'hidden' }"
              >
                <svg-icon icon-class="share_video" />
                <span>{{ videoInfo.shareNum | watchCount }}</span>
              </div>
              <div
                class="right_item pt13"
                :style="{ visibility: isEyeShow ? 'visible' : 'hidden' }"
                @click.stop="openSelectLine"
              >
                <van-icon name="sort" size="20" />
                <span class="ft12">切换线路</span>
              </div>
              <div
                class="right_item pt13 eye"
                @click.stop="isEyeShow = !isEyeShow"
              >
                <svg-icon :icon-class="isEyeShow ? 'eye_up' : 'eye_down'" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--金币购买弹窗-->
      <GoldBuy
        class="buy_parent"
        v-if="videoShow"
        :video-info="videoInfo"
        :show="isGoldbuyShow"
        @close="isGoldbuyShow = false"
        :isVip="isVip"
        @succcess="succcess"
      />
      <!-- 会员购买弹窗-->
      <VipBuy
        class="buy_parent"
        v-if="videoShow"
        :show="isVipbuyShow"
        @setVipGrap="setVipGrap"
        @close="isVipbuyShow = false"
      />
    </div>
  </div>
</template>
<script>
import VerticalScreen from "@/components/Video/VerticalScreen";
import ImgDecypt from "@/components/ImgDecypt";
import { like, userCare } from "@/api/shortVideo";
import { Toast } from "vant";
import { mapGetters } from "vuex";
import GoldBuy from "@/components/GoldBuy";
import VipBuy from "@/components/VipBuy";
// import Forward from "@/components/Forward"

export default {
  props: {
    videoShow: {
      type: Boolean,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    newUserTime: {
      type: Number,
      required: true,
    },
    timeStr: {
      type: String,
      required: true,
    },
    videoInfo: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
  },
  components: {
    VerticalScreen,
    ImgDecypt,
    GoldBuy,
    VipBuy,
    // Forward
  },
  data() {
    return {
      isEyeShow: true,
      isLoading: true, //loading
      isGoldbuyShow: false, // 金币购买弹窗
      isVipbuyShow: false, //VIP购买弹窗
      freeWatchNum: 0, //免费观看次数
      isCan: false, //是否能观看 true 能观看，false不能观看 (只有会员视频才能判断)
      isRequest: false,
    };
  },
  computed: {
    ...mapGetters({
      videoApi: "videoApi",
      userInfo: "userInfo",
      isVip: "isVip",
    }),
  },
  methods: {
    openSelectLine() {
      this.$emit("openSelectLine");
    },
    toVip() {
      let vipGrap = {
        type: "video",
        vInfo: this.videoInfo,
      };
      sessionStorage.setItem("vipGrap", JSON.stringify(vipGrap));
      this.$router.push("/vipList");
    },
    forwardSuccess() {
      this.videoInfo.forwardCount++;
    },
    unfavorite() {
      this.videoInfo.forwardCount--;
    },
    //关注
    async focus() {
      if (this.videoInfo?.author.cared) {
        return;
      }
      let uid = this.videoInfo?.author?.id;
      let req = {
        userId: parseInt(uid),
        isCare: true,
      };
      if (!uid) {
        Toast("当前用户信息错误");
        return;
      }
      try {
        let res = await this.$Api(userCare, req);
        if (res.code === 200) {
          this.videoInfo.author.cared = true;
          Toast("关注成功");
          this.$store.commit("video/UPDATE_ALL_FOCUS", uid);
        } else {
          Toast(res.tip || "关注失败");
        }
      } catch (e) {
        Toast("关注失败");
      }
    },
    //点赞
    async collecte() {
      let hasLiked = this.videoInfo?.bLike;
      let id = this.videoInfo?.id;
      let req = {
        mediaId: id,
        isLike: !hasLiked,
      };
      try {
        if (hasLiked) {
          let res = await this.$Api(like, req);
          if (res.code === 200) {
            this.videoInfo.bLike = false;
            this.videoInfo.likeNum--;
            Toast("取消点赞");
            return;
          }
          Toast(res.tip || "取消失败");
        } else {
          let res = await this.$Api(like, req);
          if (res.code === 200) {
            this.videoInfo.bLike = true;
            this.videoInfo.likeNum++;
            Toast("点赞成功");
            return;
          }
          Toast(res.tip || "点赞失败");
        }
      } catch (e) {
        Toast("操作失败");
      }
    },
    //评论
    openComments() {
      if (
        Number(this.userInfo.vipExpire * 1000) > Number(new Date().getTime()) &&
        this.userInfo.vipType
      ) {
        let params = {
          id: this.videoInfo.id,
          commentNum: this.videoInfo.commentNum,
        };
        this.$emit("openCmt", params);
      } else {
        Toast({
          message: "只有会员才能评论哦",
          duration: 1500,
        });
      }
    },
    //打开分享
    openShare() {
      this.$emit("openShare", this.videoInfo);
    },
    //前往标签页
    openTag(item) {
      this.$router.push({ path: "/tags", query: { id: item.id } });
    },
    // 购买
    paying(type) {
      if (type == "vip") {
        this.toVip();
      } else {
        this.isGoldbuyShow = true;
      }
    },
    //免费观看次数
    watchCountData(data) {
      this.freeWatchNum = data.wCount;
      this.isCan = data.isCan;
      this.isRequest = true;
    },
    // 跳转博主页
    toBloggerPage(id) {
      this.$refs.verticalScreen.cPauses();
      this.$refs.verticalScreen.videoPlayIcon(true);
      this.$router.push(`/bloggerDetails?id=${id}`);
    },
    //vip视频
    vipBuyShow() {
      this.isVipbuyShow = true;
    },
    //金币视频
    goldBuyShow() {
      this.isGoldbuyShow = true;
    },
    //购买成功
    succcess() {
      this.isGoldbuyShow = false;
      this.$refs.verticalScreen.succcess();
    },
    setVipGrap() {
      let vipGrap = {
        type: "video",
        vInfo: this.videoInfo,
      };
      sessionStorage.setItem("vipGrap", JSON.stringify(vipGrap));
    },
  },
};
</script>
<style lang="scss" scoped>
.video_warp {
  height: 100%;

  .buy_parent {
    /deep/ .van-overlay {
      position: absolute;
    }
  }

  .video_box {
    width: 100%;
    height: 100%;
    background: #000000;
    position: relative;

    .layer {
      top: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      pointer-events: none;
      text-align: left;
      z-index: 9999;

      .leftHeight {
        //height: 160px;
      }

      .left {
        position: absolute;
        bottom: 48px;
        left: 15px;
        width: 300px;
        color: #ffffff;
        pointer-events: none;

        .addres {
          max-width: 150px;
          height: 26px;
          line-height: 26px;
          font-size: 14px;
          display: inline-block;
          background: rgba(#000000, 0.4);
          color: white;
          border-radius: 6px;
          pointer-events: auto;

          > svg {
            font-size: 15px;
            padding: 0 3px 0 5px;
          }

          > span {
            padding-right: 8px;
          }
        }

        .tag {
          display: flex;
          margin: 3px 0 5px;
          pointer-events: auto;

          .tag_item {
            //max-width: 100px;
            height: 24px;
            line-height: 24px;
            display: inline-block;
            //background: rgba(#000000, 0.4);
            font-size: 14px;
            color: white;
            border-radius: 6px;
            margin-right: 5px;
            padding: 0 5px;
            text-align: center;
          }
        }

        .name_box {
          display: flex;
          padding-bottom: 5px;
          pointer-events: auto;

          .name {
            max-width: 200px;
            font-size: 16px;
            font-weight: 600;
          }

          .focus {
            margin-left: 10px;
            width: 68px;
            height: 24px;
            background: #f3792a;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;

            > svg {
              font-size: 12px;
            }
          }
        }

        .title_text {
          font-size: 14px;
          // display: -webkit-box;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          // white-space: normal !important;
          // text-overflow: ellipsis;
          // word-wrap: break-word;
          // -webkit-line-clamp: 2;
          // -webkit-box-orient: vertical;
        }

        .pay_box {
          margin-top: 5px;
          pointer-events: auto;

          .pay {
            width: 126px;
            height: 25px;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            background: #e77d2f;

            > svg {
              padding-right: 4px;
              font-size: 18px;
            }
          }

          .buied {
            font-size: 13px;
            border: 1px solid #f5164e;
            background: rgba(255, 0, 0, 0.3);
            pointer-events: none;
          }
        }
        .activityPay {
          margin-top: 5px;
          width: 210px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          background: linear-gradient(to right, #face92, #faae6c);
          border-radius: 20px;
          color: #333333;
          pointer-events: auto;
        }
        .activityPayBtn {
          pointer-events: auto;
          display: inline-block;
          height: 28px;
          line-height: 28px;
          padding: 0 10px;
          background: rgba(0, 0, 0, 0.27);
          border-radius: 28px;
          margin-bottom: 6px;
          border: 1px solid #ffffff;
          font-size: 12px;
          svg {
            font-size: 16px;
            padding-right: 4px;
          }
          .vip {
            font-size: 14px;
          }
        }
        .mr10 {
          margin-right: 10px;
        }
      }

      .right {
        position: absolute;
        right: 15px;
        bottom: 80px;
        height: 300px;
        width: 50px;
        color: #ffffff;
        pointer-events: none;

        .right_content {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          pointer-events: auto;

          .head {
            width: 48px;
            height: 48px;
            flex-shrink: 0;
            position: relative;
            margin-bottom: 15px;
            .avatar {
              border: 1px solid #fff;
              border-radius: 50%;
              /deep/ .vanImage {
                background: #00000000 !important;
              }
            }

            .add5 {
              width: 50px;
              height: 50px;
              position: absolute;
              bottom: -26px;
              display: flex;
              align-items: center;
              justify-content: center;

              .add_icon {
                display: block;
                width: 22px;
                height: 22px;
                background: url("data:image/svg+xml;base64,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");
                background-size: 100%;
              }
            }
          }

          .right_item {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            line-height: 16px;

            > span {
              font-size: 14px;
              padding-top: 2px;
            }

            > svg {
              font-size: 30px;
            }

            .share {
              line-height: 14px;

              /deep/ svg {
                font-size: 26px;
              }
            }
          }

          .eye {
            padding-top: 20px;
            > svg {
              font-size: 36px !important;
            }
          }
        }
      }
    }
  }
}

.pt13 {
  padding-top: 10px;
}
.ft12 {
  font-size: 12px !important;
}
</style>
